import React, { useEffect, useState, useRef } from "react";
import PageLayout from "../PageLayout";
import { Textarea } from "@/components/ui/textarea";
import { Button } from "@/components/ui/button";
import { IoIosSend } from "react-icons/io";
import { PiSparkle } from "react-icons/pi";
import { AiOutlineClear } from "react-icons/ai";
import toast from "react-hot-toast";
import UserMessageV2 from "@/components/ChatMessage/UserMessageV2";
import BotMessageV2 from "@/components/ChatMessage/BotMessageV2";
import DialogSelectChatbot from "@/components/Dialog/DialogSelectChatbot";
import {
  fetchChatbotAnswer,
  fetchChatbotAnswerDGSBedrock,
  fetchDGSAgentAnswer,
  getChatSessionByUUID,
} from "../../services/api/ChatService";
import { fetchTaskStatus } from "../../services/api/TaskService";
import { addAnalyticsQueryUsage } from "../../services/api/AnalyticsService";
import { useQueryCountState } from "../../states/useStates";
import { delay } from "../../services/utils";
import SpinnerChat from "@/components/Spinner/SpinnerChat";
// import DialogSelectTool from "@/components/Dialog/DialogSelectTool";
import { Tooltip as ReactTooltip } from "react-tooltip";
import { GoRocket } from "react-icons/go";
import { IoIosClose } from "react-icons/io";
// import { getCache } from "../../services/api/CacheService";
import { Link } from "react-router-dom";
import { Alert, AlertDescription, AlertTitle } from "@/components/ui/alert";
import { FaExternalLinkAlt } from "react-icons/fa";
import { IoSparkles } from "react-icons/io5";
import { NewChatDialog } from "@/components/NewChatDialog/NewChatDialog";
import { ChatHistoryDialog } from "@/components/ChatHistoryDialog/ChatHistoryDialog";
import AskUserIfChatIsHelpful from "@/components/DGS/Gridspertise/AskUserIfChatIsHelpful";
import { BaseDialog } from "@/components/Dialog/BaseDialog";

function ChatV2() {
  const [messages, setMessages] = useState([]);
  const listRef = useRef(null);
  const [lastMessage, setLastMessage] = useState();
  const [chatbot, setChatbot] = useState("");
  const [tool, setTool] = useState("");
  const [input, setInput] = useState("");
  const [asyncJobID, setAsyncJobID] = useState();
  const [queryCount, setQueryCount] = useQueryCountState();
  const [isTyping, setIsTyping] = useState(false);
  const [openExplanation, setOpenExplanation] = useState(true);
  const [showAgentIfDGSWorkspace, setShowAgentIfDGSWorkspace] = useState(false);
  const [agentIsActive, setAgentIsActive] = useState(false);
  const [chatStatus, setChatStatus] = useState("init"); // 'init', 'start'
  const [conversationUUID, setConversationUUID] = useState(null);
  const [conversationMetadata, setConversationMetadata] = useState(null);

  useEffect(() => {
    if (localStorage.getItem("company_name") === "DGS_GRIDSPERTISE") {
      setShowAgentIfDGSWorkspace(true);
    }
  }, []);

  const sendQueryAnalytics = (result) => {
    const chatbot_payload = (chatbot) => {
      if (Array.isArray(chatbot)) {
        return chatbot.join(",");
      } else {
        return chatbot;
      }
    };

    let source = "";

    if (agentIsActive) {
      source = "agent";
    } else if (agentIsActive === false && chatbot === "") {
      source = "queryRouter";
    } else {
      source = "chat";
    }

    const payload = {
      session_uuid: conversationUUID ? conversationUUID : null,
      user_sub: localStorage.getItem("sub"),
      chatbot_name: chatbot_payload(chatbot || result.index),
      company_id: localStorage.getItem("company_id"),
      query: input,
      answer: result.answer,
      total_token: result.total_tokens,
      chatbot_model: result.chatbot_model,
      source: source,
      is_agent: agentIsActive ? true : false,
    };

    addAnalyticsQueryUsage(payload);
  };

  const getAsyncResponse = async (task_id, chatbot) => {
    const res = await fetchTaskStatus(task_id);
    if (res && res.completed === true) {
      console.log("res", res.result);
      const botMessage = {
        role: "bot",
        message: res.result.answer,
        queries: res.queries,
        isLoading: false,
        chatbot: Array.isArray(res.result.index)
          ? res.result.index
          : [res.result.index] || chatbot,
        documents: res.result.documents || [],
        context: res.result.context || "",
        query: input,
        otherChatbots: [res.result.other_indexes_considered] || [],
      };

      if (!botMessage.message) {
        // toast.error(
        //   "Something went wrong during the chat. Please retry! If the error persists contact the customer service."
        // );
        setLastMessage({
          role: "bot",
          message:
            "Non sono riuscito a trovare una risposta. Puoi aiutarmi a capire meglio? In alternativa, prova a selezionare un chatbot dalla voce 'Select Chatbot' e riprova.",
          queries: res.queries,
          isLoading: false,
          chatbot: Array.isArray(res.result.index)
            ? res.result.index
            : [res.result.index] || chatbot,
          documents: res.result.documents || [],
          context: res.result.context || "",
          query: input,
        });
      } else {
        setLastMessage(botMessage);
      }
      setIsTyping(false);

      if (Object.keys(res.result).includes("total_tokens")) {
        sendQueryAnalytics(res.result);
      }
    } else {
      // Wait for a while and make the API call again
      await delay(1000); // You can adjust the delay as needed
      await getAsyncResponse(task_id, chatbot); // Recursive call
    }
  };

  const handleSendMessage = async (e) => {
    if (e.key === "Enter" && !e.shiftKey) {
      if (tool !== "" && !chatbot) {
        toast.error("To use the tool, please select a chatbot first!");
        return;
      }
      setIsTyping(true);
      setMessages([...messages, { role: "user", message: input }]);

      const payload = {
        chatbot_name: chatbot,
        company_id: localStorage.getItem("company_id"),
        tool: tool,
        query: input,
        history: messages,
      };
      setInput("");
      e.target.value = "";
      e.target.selectionStart = 0;
      e.target.selectionEnd = 0;
      e.preventDefault();

      try {
        // const cached = await getCache(payload).catch((err) => {
        //   // toast.error(
        //   //   "Something went wrong during the chat. Please retry! If the error persists contact the customer service."
        //   // );
        //   console.log("error cache", err);
        //   // setIsTyping(false);
        // });
        const cached = {};

        let res;
        if (Object.keys(cached).length > 0) {
          setLastMessage(cached);
          setIsTyping(false);
        } else {
          if (payload.chatbot_name !== "") {
            console.log("Fetching from standard endpoint");
            res = await fetchChatbotAnswer(payload).catch((err) =>
              toast.error(
                "Something went wrong during the chat. Please retry! If the error persists contact the customer service."
              )
            );
          } else {
            if (localStorage.getItem("company_name") === "DGS_GRIDSPERTISE") {
              if (agentIsActive) {
                console.log("Fetching from DGS Agent endpoint");
                const agent_payload = {
                  chatbot_name: "gridspertise-structured-data",
                  company_id: localStorage.getItem("company_id"),
                  tool: tool,
                  query: input,
                  history: messages,
                };
                res = await fetchDGSAgentAnswer(agent_payload).catch((err) =>
                  toast.error(
                    "Something went wrong during the chat. Please retry! If the error persists contact the customer service."
                  )
                );
              } else {
                console.log("Fetching from standard endpoint");
                res = await fetchChatbotAnswer(payload).catch((err) =>
                  toast.error(
                    "Something went wrong during the chat. Please retry! If the error persists contact the customer service."
                  )
                );
              }
            } else {
              console.log("Fetching from standard endpoint");
              res = await fetchChatbotAnswer(payload).catch((err) =>
                toast.error(
                  "Something went wrong during the chat. Please retry! If the error persists contact the customer service."
                )
              );
            }
          }

          if (res) {
            setAsyncJobID(res.job_id);
            getAsyncResponse(res.job_id, chatbot);
            setQueryCount(queryCount + 1);
          }
        }
      } catch {
        // toast.error(
        //   "Something went wrong during the chat. Please retry! If the error persists contact the customer service."
        // );
        setLastMessage({
          role: "bot",
          message:
            "Non sono riuscito a trovare una risposta. Puoi aiutarmi a capire meglio? In alternativa, prova a selezionare un chatbot dalla voce 'Select Chatbot' e riprova.",
          queries: "",
          isLoading: false,
          chatbot: [],
          documents: [],
          query: input,
        });
        setIsTyping(false);
        // setIsTyping(false);
      }
      // setInput("");
      // e.target.value = "";
      // e.target.selectionStart = 0;
      // e.target.selectionEnd = 0;
      // e.preventDefault();
    } else if (e.key === "Enter" && e.shiftKey) {
      setInput(input + "\n");
      e.preventDefault();
    }
  };

  const handleSendMessageOnClick = async (e) => {
    if (input) {
      setIsTyping(true);
      setMessages([...messages, { role: "user", message: input }]);

      if (tool !== "" && !chatbot) {
        toast.error("Please select a chatbot first!");
        return;
      }

      const payload = {
        chatbot_name: chatbot,
        company_id: localStorage.getItem("company_id"),
        tool: tool,
        query: input,
        history: messages,
      };

      setInput("");
      e.target.value = "";
      e.target.selectionStart = 0;
      e.target.selectionEnd = 0;
      e.preventDefault();

      try {
        // const cached = await getCache(payload).catch((err) => {
        //   toast.error(
        //     "Something went wrong during the chat. Please retry! If the error persists contact the customer service."
        //   );
        //   setIsTyping(false);
        // });
        const cached = {};
        if (Object.keys(cached).length > 0) {
          setLastMessage(cached);
          setIsTyping(false);
        } else {
          const res = await fetchChatbotAnswer(payload).catch((err) => {
            toast.error(
              "Something went wrong during the chat. Please retry! If the error persists contact the customer service."
            );
            setIsTyping(false);
          });

          if (res) {
            setAsyncJobID(res.job_id);
            getAsyncResponse(res.job_id, chatbot);
            setQueryCount(queryCount + 1);
          }
        }
      } catch {
        toast.error(
          "Something went wrong during the chat. Please retry! If the error persists contact the customer service."
        );
      }
    }
  };

  const handleNewChatCreated = (session_uuid) => {
    setMessages([]);
    setChatStatus("start");
    setConversationUUID(session_uuid.session_uuid);
    toast.success("New chat session created successfully!");
  };

  useEffect(() => {
    if (lastMessage) {
      setMessages([...messages, lastMessage]);
      setLastMessage();
    }
  }, [lastMessage]);

  useEffect(() => {
    if (chatbot) {
      toast.success("Chatbot loaded successfully!");
      agentIsActive && setAgentIsActive(false);
    }
  }, [chatbot]);

  useEffect(() => {
    listRef.current?.lastElementChild?.scrollIntoView();
  }, [messages]);

  return (
    <PageLayout>
      {chatStatus === "start" && (
        <>
          <div className="fixed left-30 flex gap-2 justify-start mt-5 flex-col">
            <ChatHistoryDialog
              onSelectChatSession={(sessionData) => {
                setMessages(sessionData.messages);
                setChatStatus("start");
                setConversationUUID(sessionData.session_uuid);
                setConversationMetadata(sessionData);
              }}
            />
            <NewChatDialog
              onCreate={(session_uuid) => handleNewChatCreated(session_uuid)}
            />
          </div>
        </>
      )}
      {/* sonner */}
      {isTyping && <SpinnerChat />}
      <div className="h-screen w-full flex justify-center">
        {chatStatus === "init" ? (
          <div className="flex items-center justify-center gap-4">
            <NewChatDialog
              text={"Start a new conversation"}
              onCreate={(session_uuid) => handleNewChatCreated(session_uuid)}
            />
            <ChatHistoryDialog
              text={"Open existing conversation"}
              onSelectChatSession={(sessionData) => {
                setMessages(sessionData.messages);
                setChatStatus("start");
                setConversationUUID(sessionData.session_uuid);
                setConversationMetadata(sessionData);
              }}
            />
          </div>
        ) : (
          <>
            <div className="grid grid-rows-6 h-full w-3/4">
              {/* messages zone */}
              <div className="row-span-5 h-full py-5 relative overflow-hidden">
                {openExplanation && messages.length === 0 && agentIsActive && (
                  <div className="absolute w-full h-5/6 flex items-center justify-center">
                    <Alert className="w-fit opacity-80">
                      <div className="flex justify-between mb-2">
                        <div className="flex gap-2">
                          <GoRocket className="h-4 w-4" />
                          <AlertTitle className="font-bold text-xl text-primary">
                            ChattoAgent is active!
                          </AlertTitle>
                        </div>
                        <IoIosClose
                          onClick={() => setOpenExplanation(false)}
                          className="cursor-pointer"
                        />
                      </div>

                      <AlertDescription>
                        <p>
                          Provide an error code or error description and Chatto
                          Agent will search for all related information in the
                          error table, <br />
                          including the corresponding use case.
                        </p>
                        <p>
                          This helps you quickly understand the meaning of the
                          error and how to address it.
                        </p>
                        <p>
                          Try{" "}
                          <span className="italic">
                            "Come risolvo il ticket con errore IN05?"
                          </span>
                        </p>
                      </AlertDescription>
                    </Alert>
                  </div>
                )}
                <div
                  className="overflow-auto h-full flex flex-col gap-5 no-scrollbar"
                  ref={listRef}
                >
                  {messages.map((message, i) => {
                    const prevMessage = i > 0 ? messages[i - 1] : null;
                    return message.role === "user" ? (
                      <div key={i} className="flex justify-end">
                        <UserMessageV2 message={message.message} />
                      </div>
                    ) : (
                      <div key={i} className="flex">
                        <BotMessageV2
                          query={message?.query || prevMessage?.message}
                          message={message.message}
                          chatbots={message.chatbot}
                          documents={message.documents}
                          onSelected={(chatbot) => setChatbot(chatbot)}
                          cached={message.cached}
                          context={message.context}
                          otherChatbots={message.otherChatbots || []}
                          agentIsActive={agentIsActive}
                        />
                      </div>
                    );
                  })}
                </div>
              </div>
              {/* chat zone */}
              <div className="w-full flex items-center py-1 gap-2 flex-col">
                {/* options */}
                <div className="w-full p-1 flex items-center gap-5">
                  <DialogSelectChatbot
                    onChatbotSelect={(v) => {
                      setChatbot(v);
                      setMessages([]);
                    }}
                    currentChatbot={chatbot}
                  />
                  {showAgentIfDGSWorkspace && (
                    <>
                      <div>
                        <button
                          className={`text-sm border border-primary px-3 py-1 rounded-md flex items-center gap-1 ${
                            agentIsActive
                              ? "bg-primary text-white"
                              : "text-primary hover:bg-primary hover:text-white"
                          }`}
                          onClick={() => {
                            setAgentIsActive(!agentIsActive);
                            setChatbot("");
                            toast.success(
                              `ChattoAgent is now ${
                                !agentIsActive ? "active" : "inactive"
                              }`
                            );
                          }}
                        >
                          <IoSparkles />
                          Activate ChattoAgent
                        </button>
                      </div>
                      <div>
                        <Link
                          to={
                            showAgentIfDGSWorkspace
                              ? "/dgs/gridspertise/schema"
                              : "/chat"
                          }
                          target="_blank"
                        >
                          <button className="text-sm border border-primary text-primary px-3 py-1 rounded-md hover:bg-primary hover:text-white flex items-center gap-1">
                            <FaExternalLinkAlt /> Explore Database Schema
                          </button>
                        </Link>
                      </div>
                      <div>
                        <AskUserIfChatIsHelpful
                          sessionuuid={conversationUUID}
                          feedbackGivenProp={
                            conversationMetadata?.general_feedback || null
                          }
                          onFeedbackGivenChange={async () => {
                            const sessionData = await getChatSessionByUUID(
                              conversationUUID
                            );
                            if (sessionData) {
                              setConversationMetadata(sessionData);
                              setConversationUUID(sessionData.session_uuid);
                            }
                          }}
                        />
                      </div>
                      {conversationMetadata?.general_feedback !== null && (
                        <BaseDialog
                          title={"Your feedback"}
                          trigger={
                            <p className="text-xs text-primary italic cursor-pointer">
                              Click to see your feedback
                            </p>
                          }
                        >
                          {conversationMetadata?.general_feedback ? (
                            <p>
                              You indicated that the chat was helpful in solving
                              your task.
                            </p>
                          ) : (
                            <p>
                              You indicated that the chat was not helpful in
                              solving your task.
                            </p>
                          )}
                          {conversationMetadata?.comment && (
                            <p className="mt-2">
                              <strong>Your comment:</strong>{" "}
                              {conversationMetadata?.comment}
                            </p>
                          )}
                        </BaseDialog>
                      )}
                    </>
                  )}
                </div>
                {/* input */}
                <div className="w-full flex relative">
                  <div className="w-full">
                    <Textarea
                      value={input}
                      onChange={(e) => setInput(e.target.value)}
                      onKeyDown={(e) => handleSendMessage(e)}
                      placeholder="Ask me anything..."
                      className=" min-h-[60px] max-h-[80px] w-full bg-transparent pr-20 resize-none focus:resize-y focus:outline-none focus:ring-transparent focus:border-primary border-gray-300"
                      autoFocus // Add this line to set the cursor on top
                    />
                  </div>
                  <div className="h-full flex items-center absolute right-5 gap-2">
                    <Button
                      variant="outline"
                      size="icon"
                      className="bg-transparent hover:bg-primary text-primary hover:text-white"
                      data-tooltip-id="clear-tooltip"
                      data-tooltip-content="Clear Chat and History"
                      onClick={() => setMessages([])}
                    >
                      <AiOutlineClear className="h-4 w-4" />
                    </Button>
                    <Button
                      variant="outline"
                      size="icon"
                      className="bg-transparent hover:bg-primary text-primary hover:text-white"
                      data-tooltip-id="send-tooltip"
                      data-tooltip-content="Send"
                      onClick={(e) => handleSendMessageOnClick(e)}
                    >
                      <IoIosSend className="h-4 w-4" />
                    </Button>

                    <ReactTooltip id="send-tooltip" />
                    <ReactTooltip id="clear-tooltip" />
                  </div>
                </div>
              </div>
            </div>
          </>
        )}
      </div>
    </PageLayout>
  );
}

export default ChatV2;
